// src/pages/LinkedinBlogEditor.jsx
import { useState } from "react";
import { marked } from "marked";
import { saveAs } from "file-saver";
import PushToGitHub from "../components/pushToGitHub";

export default function LinkedinBlogEditor() {
  const [title, setTitle] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [date, setDate] = useState(() => new Date().toISOString().slice(0, 10));
  const [image, setImage] = useState("");
  const [content, setContent] = useState("");

  function generateSlug(input) {
    return input.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
  }

  const slug = generateSlug(title);

  const article = {
    title,
    subtitle,
    date,
    image: image || `/images/blog/${slug}.jpg`,
    content,
  };

  const linkedinPost = `📢 ${title}\n\n${subtitle}\n\n👉 Jetzt lesen: https://www.denisbitter.de/post/${slug}`;

  const handleSave = () => {
    const blob = new Blob([JSON.stringify(article, null, 2)], {
      type: "application/json;charset=utf-8",
    });
    saveAs(blob, `${slug}.json`);
  };

  const handleCopyLinkedIn = () => {
    navigator.clipboard.writeText(linkedinPost).then(() => {
      alert("🔗 LinkedIn-Post in Zwischenablage!");
    });
  };

  return (
    <div className="max-w-6xl mx-auto p-6 grid grid-cols-1 md:grid-cols-2 gap-8">
      <div className="space-y-4">
        <h2 className="text-2xl font-bold">📝 Artikel + LinkedIn-Sync</h2>

        <input
          type="text"
          placeholder="Titel"
          className="w-full border p-2 rounded"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <input
          type="text"
          placeholder="Untertitel"
          className="w-full border p-2 rounded"
          value={subtitle}
          onChange={(e) => setSubtitle(e.target.value)}
        />
        <input
          type="date"
          className="w-full border p-2 rounded"
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />
        <input
          type="text"
          placeholder="Pfad zum Bild (optional)"
          className="w-full border p-2 rounded"
          value={image}
          onChange={(e) => setImage(e.target.value)}
        />
        <textarea
          placeholder="Markdown-Inhalt"
          className="w-full border p-2 h-64 rounded font-mono"
          value={content}
          onChange={(e) => setContent(e.target.value)}
        />

        <div className="flex gap-4 flex-wrap">
          <button
            onClick={handleSave}
            className="bg-black text-slate-50 px-4 py-2 rounded hover:bg-gray-800"
          >
            💾 Als JSON speichern
          </button>

          <button
            onClick={handleCopyLinkedIn}
            className="bg-blue-600 text-slate-50 px-4 py-2 rounded hover:bg-blue-700"
          >
            🔗 LinkedIn-Vorschau kopieren
          </button>
        </div>

        <PushToGitHub content={article} defaultSlug={slug} />
      </div>

      <div>
        <h3 className="text-xl font-semibold mb-2">🔍 Vorschau</h3>
        <div
          className="prose prose-sm max-w-none border p-4 rounded"
          dangerouslySetInnerHTML={{ __html: marked.parse(content || "") }}
        />
        <div className="mt-6 p-4 border rounded text-sm bg-gray-50">
          <p className="font-bold mb-1">📎 LinkedIn-Post Vorschau:</p>
          <pre className="whitespace-pre-wrap">{linkedinPost}</pre>
        </div>
      </div>
    </div>
  );
}
